// Function to observe buttons and match them with anchors from the panel data-trigger attribute
function observeButtonsFromData() {
    // Get the existing anchors from the 'data-existing-anchors' attribute
    const panel = document.querySelector('.cta-panels');
    const existingAnchors = panel.getAttribute('data-existing-anchors').split('#').filter(Boolean).map(anchor => `#${anchor}`);

    // Iterate over each anchor and attach click events to matching <a> elements
    existingAnchors.forEach(anchor => {
        const buttons = document.querySelectorAll(`a[href="${anchor}"]`);

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const formPanel = document.querySelector(`.cta-panels__panel--form[data-trigger="${anchor}"]`);
                if (formPanel) {
                    console.log(`Wywołano formularz powiązany z kotwicą ${anchor}`);
                    
                    // Add active class to form panel and background
                    formPanel.classList.add('cta-panels__panel--active');
                    document.querySelector('.bg-for-side-panels').classList.add('bg-for-side-panels--active');
                }
            });
        });
    });
}

// Function to observe expert buttons (unchanged)
function observeExpertButtons() {
    const expertButtons = document.querySelectorAll('a[href="#kontakt-z-ekspertem"], a[href="#contact-with-expert"]');
    
    expertButtons.forEach(button => {
        button.addEventListener('click', () => {
            console.log("Wywołano kontakt z ekspertem");
            
            // Add active class to expert panel and background
            document.querySelector('.cta-panels__panel--expert').classList.add('cta-panels__panel--active');
            document.querySelector('.bg-for-side-panels').classList.add('bg-for-side-panels--active');
        });
    });
}

// Close panel function for individual close buttons
function observeCloseButtons() {
    const closeButtons = document.querySelectorAll('.cta-panels__close');
    closeButtons.forEach(closeButton => {
        closeButton.addEventListener('click', (e) => {
            const panel = closeButton.closest('.cta-panels__panel');
            if (panel) {
                // Remove active class from the specific panel
                panel.classList.remove('cta-panels__panel--active');
            }

            // Remove active class from background if all panels are closed
            const allPanels = document.querySelectorAll('.cta-panels__panel--active');
            if (allPanels.length === 0) {
                document.querySelector('.bg-for-side-panels').classList.remove('bg-for-side-panels--active');
            }
            history.replaceState(null, "", window.location.pathname + window.location.search);
        });
    });
}

// Background click to close panel (unchanged)
function observeBackgroundClick() {
    const bgPanel = document.querySelector('.bg-for-side-panels');
    if (bgPanel) {
        bgPanel.addEventListener('click', () => {
            // Remove active class from form panel and expert panel
            document.querySelectorAll('.cta-panels__panel--active').forEach(panel => {
                panel.classList.remove('cta-panels__panel--active');
            });
            // Remove active class from background
            bgPanel.classList.remove('bg-for-side-panels--active');
            history.replaceState(null, "", window.location.pathname + window.location.search);
        });
    }
}

// Initialize observation for dynamically matched anchors
observeButtonsFromData();  // Dynamically match anchors to form panels
observeExpertButtons();    // Unchanged, handles the expert buttons

// Initialize close button and background click observations
observeCloseButtons();  // Handle multiple close buttons per panel
observeBackgroundClick();
